export class RequestError extends Error {
    code: string;
    result: any;

    constructor(code: string, result: any) {
        super('Fel på begäran');
        this.code = code;
        this.result = result;
    }
}
